<template lang="pug">
  .simple-form
    .btn-notice(@click="noticeVisible = true") 活动规则
    .card
      .header
        .label 话费充值资格卷
        .name 30元手机话费
        .left-time
          span {{time.m}}
          | :
          span {{time.s}}
          | :
          span {{time.ms}}
          | 后结束
      hr
      .deadline {{date}}(限时领取)
      .mobile-form
        el-form
          el-form-item
            el-input.order-txt(type="text", v-model="form.mobile", placeholder="输入手机号抢30元话费")
          el-form-item
            el-input.order-txt(type="text", placeholder="请输入验证码", v-model="form.verifyCode", maxlength="6")
              el-button.sms-button(slot="append", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后可重试
          el-form-item
            el-button.btn-submit(@click="handleSubmit") 立即使用
    el-dialog(
      title="活动规则"
      :visible.sync="noticeVisible"
      width="90%"
      :center="true"
    )
      ol.notice-list
        li(v-for="item in notices", :key="item") {{item}}
</template>

<script>
export default {
  data() {
    return {
      noticeVisible: false,
      leftSendTime: 0,
      channel: 'TUIA',
      time: {
        m: '03',
        s: '00',
        ms: '00'
      },
      date: '',
      form: {
        mobile: '',
        verifyCode: '',
        goodsCode: 'WXPAPAY210226001'
      },
      maxLeftTime: 3 * 60 * 1000,
      notices: [
        '权益说明：客户首月只需支付9.9元后，即可享30元话费券、外卖红包、视频会员、陀螺好物、爱奇艺会员1折起、移动花卡免费领取，次月起恢复29.9元，享受6款会员专属特权。',
        '权益领取：以上6款会员权益均可通过微信搜索关注“language会员”公众号，在会员权益中通过支付关联的手机号码领取，会员生效期间，30元话费券、视频会员每月均可领取，其余4款会员特权一直可领取。',
        '30元话费券为6张*5元话费减免券，可在“language会员”公众号充值100元话费时直接使用，即仅需支付95元即可获得100元话费。',
        '陀螺好物即百种商品免费领权益，可跳转至微信小程序“陀螺好物”中按页面说明完成相应任务即可免费领取百种商品。',
        '爱奇艺会员最低1元购买权益：最低支付1元购买爱奇艺月度会员。',
        '外卖红包权益：每天可通过“language会员”公众号，领取最高66元的美团外卖红包。',
        '注意事项：请在购买时务必填写正确的需充值的手机号码及短信验证码，本产品为系统自动办理，人工无法手动取消办理或者退款，敬请谅解。',
      ],
      channelOrderNo: ''
    }
  },
  mounted() {
    let _now = new Date()
    let _month = _now.getMonth() + 1
    let _day = _now.getDay()
    this.date = `${_now.getFullYear()}.${_month < 10 ? '0' + _month : _month}.${_day < 10 ? '0' + _day : _day}`
    this.costLeftTime()
    // eslint-disable-next-line
    let _queryStr = location.search.replace(/^\?/, '') + location.hash.replace(/^\#/, '&')
    let _oid = this.$route.query.a_oId
    if (_queryStr && !_oid) {
      let _querys = _queryStr.split('&')
      _querys.forEach(item => {
        // eslint-disable-next-line
        if (/^a\_oId\=/.test(item)) {
          _oid = item.split('=')[1]
        }
      })
    }
    this.channelOrderNo = _oid
  },
  methods: {
    costLeftTime() {
      if (this.maxLeftTime > 20) {
        this.maxLeftTime = this.maxLeftTime - 20
        let _m = Math.floor(this.maxLeftTime / (60 * 1000))
        let _s = Math.floor((this.maxLeftTime - _m * 60 * 1000) / 1000)
        let _ms = this.maxLeftTime % 1000
        this.time.m = '0' + _m
        this.time.s = _s < 10 ? '0' + _s : _s
        if (_ms > 100) {
          this.time.ms = _ms.toString().substr(0, 2)
        } else if(_ms < 10) {
          this.time.ms = '0' + _ms
        } else {
          this.time.ms = _ms
        }
        setTimeout(() => {
          this.costLeftTime()
        }, 20)
      } else {
        this.time.m = '00'
        this.time.s = '00'
        this.time.ms = '00'
      }
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在发送验证码...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .sendWXPayVerifyCode({
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在验证，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.OrderService
        .checkVerifyCode({
          mobile: this.form.mobile,
          code: this.form.verifyCode,
          goodsCode: this.form.goodsCode,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
              if (window.localStorage) {
                localStorage.setItem('language-member-order', JSON.stringify({
                  mobile: this.form.mobile,
                  verifyCode: this.form.verifyCode,
                  oid: this.channelOrderNo
                }));
              } 
              let _rurl = encodeURIComponent(`https://${location.host}/language/wxconfirmorder/${this.form.mobile}/${this.form.verifyCode}/${this.channelOrderNo}`)
              location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx286150fcfe66751c&redirect_uri=${_rurl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
            } else {
              if (window.localStorage) {
                localStorage.setItem('language-member-order', JSON.stringify({
                  mobile: this.form.mobile,
                  verifyCode: this.form.verifyCode,
                  oid: this.channelOrderNo
                }));
                this.$router.push({
                  name: 'lanConfirmOrder'
                })
              } else {
                this.$router.push({
                  name: 'lanConfirmOrder',
                  query: {
                    mobile: this.form.mobile,
                    verifyCode: this.form.verifyCode,
                    oid: this.channelOrderNo
                  }
                })
              }
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，请稍候再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.simple-form{
  background-color: #268859;
  min-height: 50rem;
  padding-top: 10rem;
}
.card{
  background-color: #fff;
  width: 90%;
  margin: 0 auto;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  text-align: center;
  .header{
    .label{
      background: linear-gradient(to left,#ff8900,#ff5907);
      position: absolute;
      right: 0;
      top: 0;
      color: #fff;
      font-size: .8rem;
      padding: .4rem;
    }
    .name{
      font-size: 1.8rem;
      margin-top: 1.5rem;
      color: #333;
      font-weight: bold;
    }
    .left-time{
      margin: .5rem 0;
      font-size: .8rem;
      span{
        display: inline-block;
        width: 1.4rem;
        background-color: #d2f6e5;
      }
    }
  }
  .deadline{
    margin: .5rem 0;
    font-size: .8rem;
  }
  .mobile-form{
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
    .btn-submit{
      width: 90%;
      border: 0;
      background-color: #268859;
      color: #fff;
      border-radius: 24px;
      font-size: 1.2rem;
    }
  }
}
.btn-notice{
  position: absolute;
  background: linear-gradient(180deg,#faedcf 0,#dfc080 100%);
  right: 0;
  top: 3rem;
  writing-mode: vertical-lr;
  padding: .4rem .3rem;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  font-size: 1rem;
  letter-spacing: .1rem;
}
.notice-list{
  list-style-type: decimal;
  padding-left: 1rem;
  max-height: 30rem;
  overflow: auto;
}
</style>